var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWarningIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 19,
    viewBox: "0 0 16 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_16824_144787)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.9817 4.56601C8.88271 4.39358 8.73998 4.25031 8.56791 4.15069C8.39584 4.05106 8.20053 3.9986 8.0017 3.9986C7.80287 3.9986 7.60756 4.05106 7.43549 4.15069C7.26343 4.25031 7.12069 4.39358 7.0217 4.56601L0.164702 16.233C-0.292298 17.011 0.255702 18 1.1447 18H14.8577C15.7467 18 16.2957 17.01 15.8377 16.233L8.9817 4.56601ZM7.9997 8.00001C8.5347 8.00001 8.9537 8.46201 8.8997 8.99501L8.5497 12.502C8.53794 12.6398 8.4749 12.7681 8.37306 12.8616C8.27121 12.9552 8.13797 13.0071 7.9997 13.0071C7.86143 13.0071 7.72819 12.9552 7.62635 12.8616C7.5245 12.7681 7.46146 12.6398 7.4497 12.502L7.0997 8.99501C7.08713 8.86925 7.10105 8.74224 7.14055 8.62218C7.18005 8.50212 7.24426 8.39166 7.32905 8.29792C7.41383 8.20419 7.51731 8.12925 7.63282 8.07794C7.74833 8.02663 7.87331 8.00008 7.9997 8.00001ZM8.0017 14C8.26692 14 8.52127 14.1054 8.70881 14.2929C8.89634 14.4804 9.0017 14.7348 9.0017 15C9.0017 15.2652 8.89634 15.5196 8.70881 15.7071C8.52127 15.8947 8.26692 16 8.0017 16C7.73649 16 7.48213 15.8947 7.2946 15.7071C7.10706 15.5196 7.0017 15.2652 7.0017 15C7.0017 14.7348 7.10706 14.4804 7.2946 14.2929C7.48213 14.1054 7.73649 14 8.0017 14Z",
    fill: "#FACC15"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_16824_144787"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0 3)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningIcon);
export default __webpack_public_path__ + "static/media/warning-icon.53f22930d8304cb58c6d9edb1a8a943b.svg";
export { ForwardRef as ReactComponent };